/*
 * House of Daisy — fifteen-minute holds on one-of-a-kind pieces, through
 * the House of Daisy app (/apps/hod/hold). The hold is soft: stock stays
 * available in Shopify so the bride holding it can check out, and the
 * theme pauses the buy button for anyone else until the hold lapses.
 * If the app does not answer, nothing changes on the page.
 */
(function () {
  if (window.hodHoldLoaded) return;
  window.hodHoldLoaded = true;

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function copy() {
    var node = document.querySelector('[data-hod-hold-copy]');
    var c = node ? JSON.parse(node.textContent) : {};
    Object.keys(c).forEach(function (k) {
      c[k] = decode(c[k]);
    });
    return c;
  }

  function cartToken() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return cart.token || '';
      });
  }

  function minutesLeft(iso) {
    return Math.max(0, Math.ceil((Date.parse(iso) - Date.now()) / 60000));
  }

  function take(el, token) {
    var body = new FormData();
    body.append('variant_id', el.dataset.variant);
    body.append('product_id', el.dataset.product);
    body.append('cart_token', token);
    return fetch('/apps/hod/hold', { method: 'POST', body: body, headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function show(el, state, c) {
    if (!state || !state.expires_at) {
      el.hidden = true;
      return;
    }
    var tick = function () {
      var min = minutesLeft(state.expires_at);
      el.hidden = false;
      el.classList.toggle('hod-hold--other', !state.mine);
      if (state.mine) {
        el.textContent = min > 0 ? c.mine.replace('[min]', min) : c.mineExpired;
      } else {
        el.textContent = c.other.replace('[min]', Math.max(1, min));
      }
      return min;
    };
    tick();
    clearInterval(el._hodTimer);
    el._hodTimer = setInterval(function () {
      if (tick() <= 0) clearInterval(el._hodTimer);
    }, 30000);
  }

  function pauseBuy(paused) {
    document.querySelectorAll('product-form button[name="add"], .shopify-payment-button button').forEach(function (b) {
      b.disabled = paused;
      if (paused) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });
  }

  function init() {
    var c = copy();
    var product = document.querySelector('[data-hod-hold="product"]');
    var cartLines = document.querySelectorAll('[data-hod-hold="cart"]');
    if (!product && !cartLines.length) return;

    cartToken().then(function (token) {
      // Cart: take or renew her hold on each one-of-a-kind line.
      var line = function (el) {
        if (el.dataset.hodHoldSeen) return;
        el.dataset.hodHoldSeen = '1';
        take(el, token).then(function (state) {
          show(el, state, c);
        });
      };
      cartLines.forEach(line);
      // Dawn replaces the lines whenever the cart changes (a quantity here, or a refresh started elsewhere on the page):
      // each new line is taken and shown when it appears — not on a timer, which could read the old lines before the
      // new ones arrived (a review, 2026-09-29).
      if (cartLines.length && window.MutationObserver) {
        new MutationObserver(function (changes) {
          changes.forEach(function (change) {
            change.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches('[data-hod-hold="cart"]')) line(node);
              node.querySelectorAll('[data-hod-hold="cart"]').forEach(line);
            });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }

      if (!product) return;
      // Product page: is someone else holding it?
      // By POST: her cart token goes in the form body, never in an address (addresses are written to request logs).
      var ask = new FormData();
      ask.append('intent', 'state');
      ask.append('variant_ids', product.dataset.variant);
      ask.append('cart_token', token);
      fetch('/apps/hod/hold', { method: 'POST', body: ask, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          var h = data && data.holds && data.holds[0];
          if (h) {
            show(product, h, c);
            pauseBuy(!h.mine);
            if (!h.mine) {
              setTimeout(function () {
                pauseBuy(false);
                product.hidden = true;
              }, Math.max(0, Date.parse(h.expires_at) - Date.now()));
            }
          }
        })
        .catch(function () {});

      // When she adds it to her cart, the hold starts.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'product-form' && String(event.productVariantId) === product.dataset.variant) {
            cartToken().then(function (t) {
              take(product, t).then(function (state) {
                show(product, state, c);
              });
            });
          }
        });
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
